module.exports = "/images/intercard.png?5979d8d31dc121b4914cf1545338fa5c";